
import OwlCarousel from 'react-owl-carousel'

function Testimonial({data}:any) {
    return ( 
        <div className="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="section-title text-center position-relative pb-3 mb-4 mx-auto" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-danger text-uppercase">نظرات کاربران</h5>
                    <h1 className="mb-0">کاربران درباره GREhub چه می گویند </h1>
                </div>
                <OwlCarousel className="testimonial-carousel wow fadeInUp" data-wow-delay="0.6s" loop nav={false} dots={true} center={true} 
                    autoplay={true} smartSpeed={1500} 
                    responsive={
                        {
                            0:{
                                items:1
                            },
                            576:{
                                items:1
                            },
                            768:{
                                items:2
                            },
                            992:{
                                items:3
                            }
                        }
                    }>
                    {data.map((row:any,index:number) => 
                    <div className="testimonial-item bg-light my-4" key={index}>
                        <div className="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                            <img className="img-fluid rounded" src={row.profile} alt={row.name} style={{width: "60px", height: "60px"}} />
                            <div className="ps-4">
                                <h4 className="text-danger mb-1">{row.name}</h4>
                                <small className="text-uppercase">{row.career}</small>
                            </div>
                        </div>
                        <div className="pt-4 pb-5 px-5">{row.comment}</div>
                    </div>)}
                </OwlCarousel>
            </div>
        </div>
     );
}

export default Testimonial;